//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { listCustomBranches } from '@/graphql/api/gitBranch';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: String,
      default: '',
    },
    defaultBranch: {
      type: String,
      default: '',
    },
    defaultBuildBranch: {
      type: String,
      default: '',
    },
    robotOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      buildBranch: '',
      branch: '',
      robot: '',
      remark: '',
      buildBranchOptions: [],
      buildBranchAllOptions: [],
      buildBranchLoading: false,
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        this.buildBranch = this.defaultBuildBranch || '';
        this.branch = this.defaultBranch || '';
        this.robot = '';
        this.loadBuildBranches();
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async loadBuildBranches(keyword = '') {
      this.buildBranchLoading = true;
      try {
        const res = await listCustomBranches({
          keyword,
          limit: 50,
        });
        const options = res?.branches || [];
        if (this.defaultBuildBranch && !options.includes(this.defaultBuildBranch)) {
          options.unshift(this.defaultBuildBranch);
        }
        this.buildBranchAllOptions = options;
        this.buildBranchOptions = options;
      } catch (error) {
        this.buildBranchAllOptions = this.defaultBuildBranch ? [this.defaultBuildBranch] : [];
        this.buildBranchOptions = this.buildBranchAllOptions;
      } finally {
        this.buildBranchLoading = false;
      }
    },
    queryBuildBranches(keyword = '') {
      this.loadBuildBranches(keyword);
    },
    submit() {
      if (!this.buildBranch || (this.tab === 'mp' && !this.branch)) {
        this.$message.error('分支不能为空');
        return;
      }
      const data = {
        customBranch: this.buildBranch,
      };
      if (this.tab === 'mp') {
        data.branch = this.branch;
        if (this.robot) {
          data.robot = this.robot;
        }
      }
      this.$emit('submit', data);
    },
  },
};
